import _defineProperty from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import styled from 'styled-components';
import Fab from '@mui/material/Fab';
import { makeStyles } from '@mui/styles';
// import IconButton from '@material-ui/core/IconButton';

export var VideoContainer = styled.div.withConfig({
  displayName: "style__VideoContainer",
  componentId: "sc-x0w1vc-0"
})(["display:flex;padding:1rem;", ""], function (_ref) {
  var fullWidth = _ref.fullWidth;
  return fullWidth ? 'width: 100%;' : "margin-right: -50px;";
});
export var CloseBtn = styled(Fab).withConfig({
  displayName: "style__CloseBtn",
  componentId: "sc-x0w1vc-1"
})(["right:50px;top:10px;"]);
export var LinkContainer = styled.div.withConfig({
  displayName: "style__LinkContainer",
  componentId: "sc-x0w1vc-2"
})(["display:flex;margin:0.75rem 0;&&{a{display:flex;color:", ";align-items:center;text-decoration:none;svg{font-size:1.3rem;}}}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.grey[500];
});
export var useClasses = makeStyles(function (theme) {
  return {
    video: _defineProperty({}, theme.breakpoints.down('xs'), {
      width: '250px',
      height: '175px'
    })
  };
});